import GenericTooltip from "@ui-components/Tooltip/GenericTooltip";
import * as React from "react";
import { ReactComponent as IconInformation } from "../../shared/assets/Icons/Iconinformation.svg";

interface RadioCardProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  className?: string;
  containerClassName?: string;
  description?: string;
  checked?: boolean;
  /**
   * Tooltip text that appears next to the label.
   */
  tooltipText?: string;
  /**
   * Tooltip position (top, bottom, left, right).
   * @default "top"
   */
  tooltipPosition?: "top" | "bottom" | "left" | "right";
  /**
   * Clase Tailwind opcional para establecer un min-width.
   * @default "min-w-[140px]"
   */
  minWidthClass?: string;
  /**
   * Clase Tailwind opcional para establecer un max-width.
   * @default "max-w-[504px]"
   */
  maxWidthClass?: string;
}

const GenericRadioCard = React.forwardRef<HTMLInputElement, RadioCardProps>(
  ({ 
    containerClassName, 
    label,
    description,
    checked,
    tooltipText,
    tooltipPosition = "top",
    maxWidthClass = "max-w-[420px]",
    ...props }, ref) => {
    return (
      <label
        className={`flex items-center gap-3 rounded-lg border bg-card p-3 cursor-pointer transition-colors hover:bg-accent ${
          containerClassName || ""
        } ${maxWidthClass}`}
      >
        <div className="relative flex h-6 w-6 items-center justify-center">
          <div
            className={`absolute inset-0 rounded-full border-2 border-muted-foreground/30 ${
              checked ? "border-primary" : ""
            }`}
          />
          <input
            type="radio"
            ref={ref}
            checked={checked}
            {...props}
            className={`peer h-4 w-4 cursor-pointer rounded-full border-0 outline-none ring-0 focus:ring-0 focus:ring-offset-0
              text-primary checked:border-primary checked:bg-primary
              disabled:cursor-not-allowed disabled:opacity-50`}
          />
        </div>
        {/* Label and Tooltip */}
        <div className="flex flex-col">
          <span className="text-sm text-semantic-text-primary font-medium flex items-center gap-2">
            {label}
            {tooltipText && <GenericTooltip text={tooltipText} position={tooltipPosition} icon={<IconInformation />}/> }
          </span>
          {description && (
            <span className="text-xs text-semantic-text-secondary">{description}</span>
          )}
        </div>
      </label>
    );
  }
);

GenericRadioCard.displayName = "RadioCard";
export { GenericRadioCard };
